import React, { useEffect, useState } from "react";
import { axios_helper_no_header } from "../../../common_nextgen/axios/AxiosHelper";

import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";

import getBackendUrl from "../../../environment/BackendService";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";

import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";


const usePriceSchedule = () => {
  const [data, setData] = useState([]); /* Price Schedule Data */
  const [paramsData, setParamsData] = useState({
    prcPriceScheduleName: "",
    prcPriceScheduleDesc: "",
    hiddenRecordIndicator: "Active",
  });
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const [hideSelectedOption, setHideSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const {
    ADD_PRICE_SCHEDULE,
    EDIT_PRICE_SCHEDULE,
    DISPLAY_PRICE_SCHEDULE,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;

  const screen_title = "Price Schedule";
  const screenNumber = "RCPRC003";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "PRC Price Schedule Name",
      name: "prcPriceScheduleName",
      label: "Schedule",
      type: "text",
      maxLength: 10,
    },
    {
      fieldLabel: "PRC Price Schedule Desc",
      name: "prcPriceScheduleDesc",
      label: "Description",
      type: "text",
      value: "",
      maxLength: 25,
    },
    {
      fieldLabel: "Hidden Record IndicatorValid Values",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      value: "",
      maxLength: 0,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [
    { field_label: "Hidden Record Indicator", condition: "Valid Values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Add Price Schedule",
      button_handeler: () => {
        navigateToPage(ADD_PRICE_SCHEDULE, {
          previousScreen: location.pathname,
        });
      },
      button_key: "F6",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */

  const menuOptions = [
    {
      label: "Note",
      icon: <span className="material-icons">note</span>,
      command: () => {
        navigateToPage(PRICE_SCHEDULE_NOTE, {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData.prcPriceScheduleName],
          previousScreen: location.pathname,
        });
      },
    },
    {
      label: "Edit",
      icon: <span className="material-icons">edit</span>,
      command: () => {
        navigateToPage(EDIT_PRICE_SCHEDULE, {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData.prcPriceScheduleName],
          previousScreen: location.pathname,
        });
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">visibility</span>,
      command: () => {
        navigateToPage(DISPLAY_PRICE_SCHEDULE, {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData.prcPriceScheduleName],
          previousScreen: location.pathname,
        });
      },
    },
    {
      label: "Copy",
      icon: <span className="material-icons">content_copy</span>,
      command: () => {
        navigateToPage(COPY_PRICE_SCHEDULE, {
          selectedPriceSchedules: selectedRows.length
            ? selectedRows
            : [rowData.prcPriceScheduleName],
          previousScreen: location.pathname,
        });
      },
    },
    {
      label: "Delete",
      icon: <span className="material-icons">delete</span>,
      command: () => {
        openConfirmationModal();
      },
    },
    {
      label: "Hide",
      icon: <span className="material-icons">visibility_off</span>,
      command: () => {
        openHideConfirmationModal();
      },
    },
    {
      label: "Client Price Schedules",
      icon: <span className="material-icons">group</span>,
      command: () => {
        console.log("Client Price Schedules");
      },
    },
    {
      label: "Plans",
      icon: <span className="material-icons">event</span>,
      command: () => {
        console.log("Plans");
      },
    },
    {
      label: "Criteria",
      icon: <span className="material-icons">filter_list</span>,
      command: () => {
        console.log("Criteria");
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Schedule",
      field: "prcPriceScheduleName",
    },
    {
      header: "Description",
      field: "prcPriceScheduleDesc",
    },
    {
      header: "Status",
      field: "hiddenRecordIndicator",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "prcPriceScheduleName";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/priceschedule`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        console.log("response.length is ", response.length);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);

        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };
  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, hideSelectedOption, selectedOption]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const openHideConfirmationModal = () => {
    setIsHideConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const closeHideConfirmationModal = () => {
    console.log(hideSelectedOption);
    setIsHideConfirmationModalOpen(false);
    setHideSelectedOption("no");
  };

  const hidePriceSchedule = () => {
    if (hideSelectedOption === "yes") {
      const params = {
        prcPriceScheduleName: rowData[parmKey],
        screenNumber: screenNumber,
      };
      axios_helper_no_header("PUT", "api/priceschedule/hide", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeHideConfirmationModal();
        });
    } else {
      closeHideConfirmationModal();
    }
  };

  const deletePriceSchedule = () => {
    if (selectedOption === "yes") {
      const params = { prcPriceScheduleName: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/priceschedule", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/priceschedule/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    isHideConfirmationModalOpen,
    closeConfirmationModal,
    closeHideConfirmationModal,
    deletePriceSchedule,
    hidePriceSchedule,
    setSelectedOption,
    setHideSelectedOption,
  };
};

export default usePriceSchedule;
